/// <reference types="vite/client" />

// apps/patient/src/config/platforms.ts 

export interface Platform {
    id: string;
    name: string;
    shortName: string;
    description: string;
    themeColor: string;
    backgroundColor: string;
    domain: {
      production: string;
      demo: string;
    };
  }
  

  export const PLATFORMS : Record<string, Platform> = {
    ehr: {
        id: 'ehr',
        name: 'PrismEHR',
        shortName: 'PrismEHR',
        description: 'Electronic Health Record',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'platform.prismehr.com',
            demo: 'demo-platform.yourcompany.com'
        }
    },
    formbuilder: {
        id: 'formbuilder',
        name: 'CuratoForm',
        shortName: 'CuratoForm',
        description: 'Healthcare Form Builder',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'app.curatoform.com',
            demo: 'demo-app.curatoform.com'
        }
    },
    prescription: {
        id: 'prescription',
        name: 'eRx Mobile',
        shortName: 'eRx Mobile',
        description: 'Electronic Prescription Platform',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'app.erxmobile.com',
            demo: 'demo.erxmobile.com'
        }
    },
    exercise: {
        id: 'exercise',
        name: 'Ready2Exercise',
        shortName: 'Ready2Exercise',
        description: 'AI Powered Fitness Platform',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'platform.ready2exercise.com',
            demo: 'demo-platform.ready2exercise.com'
        }
    },
    rehab: {
        id: 'rehab',
        name: 'Rehab Prescribed',
        shortName: 'Rehab Prescribed',
        description: 'Home Exercise Programs',
        themeColor: '#0facd7',
        backgroundColor: '#ffffff',
        domain: {
            production: 'platform.rehabprescribed.com',
            demo: 'demo-platform.rehabprescribed.com'
        }
    }
};
  
  // Get current platform configuration based on environment variables
  export function getCurrentPlatform(): Platform {
    const platformId = import.meta.env.VITE_PLATFORM_ID || 'ehr';
    const platform = PLATFORMS[platformId as keyof typeof PLATFORMS];
    
    if (!platform) {
      console.error(`Invalid platform ID: ${platformId}`);
      return PLATFORMS.ehr; // Fallback to EHR
    }
    
    return platform;
  }
  
  // Get current environment
  export function getCurrentEnvironment(): 'production' | 'demo' {
    return (import.meta.env.VITE_ENVIRONMENT || 'production') as 'production' | 'demo';
  }
  
  // Check if we're in demo environment
  export function isDemoEnvironment(): boolean {
    return getCurrentEnvironment() === 'demo';
  }
  
  // Get all environment-specific configuration
  export interface EnvironmentConfig {
    platform: Platform;
    environment: 'production' | 'demo';
    apiBaseUrl: string;
    stripeKey: string;
    privateFilesEnabled: boolean;
    appName: string;
    appShortName: string;
    themeColor: string;
    domain: string;
  }
  
  export function getEnvironmentConfig(): EnvironmentConfig {
    const platform = getCurrentPlatform();
    const environment = getCurrentEnvironment();
    
    return {
      platform,
      environment,
      apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://test-api.rehabilitationhealth.com/api:RIB0KqtX',
      stripeKey: import.meta.env.VITE_STRIPE_KEY || '',
      privateFilesEnabled: import.meta.env.VITE_PRIVATE_FILES_ENABLED === 'true',
      appName: import.meta.env.VITE_APP_NAME || platform.name,
      appShortName: import.meta.env.VITE_APP_SHORT_NAME || platform.shortName,
      themeColor: import.meta.env.VITE_THEME_COLOR || platform.themeColor,
      domain: platform.domain[environment]
    };
  }